import { createFileRoute, redirect } from "@tanstack/react-router";
import { meQueryOptions } from "@/features/auth/api/auth.queries";
import { usersQueryOptions } from "@/features/roster/api/roster.queries";
import { RosterPage } from "@/features/roster/RosterPage";
import { canManageRoster } from "@/shared/lib/roles";

export const Route = createFileRoute("/_app/roster")({
  beforeLoad: async ({ context }) => {
    // Parent _app guard ensured auth + non-applicant (me cached); this narrows to officers/admins.
    const me = await context.queryClient.fetchQuery(meQueryOptions);
    if (!canManageRoster(me.permissionRole)) {
      throw redirect({ to: "/" });
    }
  },
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(usersQueryOptions),
  component: RosterPage,
});
